<template>
    <v-card>
      <Loading :value="loading" ></Loading>

      <v-card-text>
        <v-container fluid grid-list-md>
          <v-layout row>
            <v-flex md3>
              <el-row :gutter="20">
                <div class="grid-content" style="padding:3px; margin:5px">
                  <el-row>
                    <el-card class="box-card">
                      <div class="grid-content bg-purple">
                        <div class="text item">
                          <v-layout row>
                            <v-flex md12>
                              <p><b>Désignation : </b> {{ detailBanque.libelle }} </p>
                              <p><b>Gérant : </b> {{ detailBanque.gerant }} </p>
                              <p><b>Type de trésorerie : </b>
                                <v-chip text-color="white" label color="orange">
                                  BANQUE
                                </v-chip>
                              </p>
                              <p><b>Etat : </b>
                                <v-chip v-if="detailBanque.etat === false" text-color="white" label color="red">
                                  FERME
                                </v-chip>
                                <v-chip v-if="detailBanque.etat === true" text-color="white" label color="green">
                                  OUVERT
                                </v-chip>
                              </p>
                              <p><b>Solde Initial : </b>
                                <v-chip text-color="white" label color="primary">
                                  {{detailBanque.soldeInitial}} FCFA
                                </v-chip>
                              </p>
                              <p><b>Solde : </b>
                                <v-chip text-color="white" label color="primary">
                                  {{detailBanque.solde}} FCFA
                                </v-chip>
                              </p>
                              <p><b>Date d'enrégistrement : </b> {{detailBanque.created}} </p>
                              <p><b>Date de modification : </b> {{detailBanque.modified}}</p>
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                    </el-card>
                  </el-row>
                </div>
                <br/>
              </el-row>
            </v-flex>

            <!-- COLONNE DE DROITE -->
            <v-flex md9>
              <!-- TABLEAU DE STATS -->
              <v-container fluid grid-list-md>
                <v-layout row justify>
                  <v-flex md4>
                    <div id="chartAllBilanBanque" style="width:950px; height:300px"></div>
                  </v-flex>
                </v-layout>
              </v-container>


              <!-- RESUME DES SOLDES -->
              <el-row :gutter="20">
                <div class="grid-content" style="padding:3px; margin:5px">
                  <el-row>
                    <v-container fluid grid-list-md>
                      <v-layout row>
                        <v-flex md4>
                          <el-card class="box-card">
                            <v-chip text-color="white" label color="primary" style="font-size:19px; width:100%">
                              SOLDE
                            </v-chip>
                            <v-chip text-color="white" label color="primary" style="font-size:19px; width:100%">
                              {{detailBanque.solde}} FCFA
                            </v-chip>
                          </el-card>
                        </v-flex>
                        <v-flex md4>
                          <el-card class="box-card">
                            <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                              CREDIT
                            </v-chip>
                            <v-chip text-color="white" label color="green" style="font-size:19px; width:100%">
                              {{montantEntree}} FCFA
                            </v-chip>
                          </el-card>
                        </v-flex>
                        <v-flex md4>
                          <el-card class="box-card">
                            <v-chip text-color="white" label color="red" style="font-size:19px; width:100%">
                              DEBIT
                            </v-chip>
                            <v-chip text-color="white" label color="red" style="font-size:19px; width:100%">
                              {{montantSortie}} FCFA
                            </v-chip>
                          </el-card>
                        </v-flex>
                      </v-layout>

                    </v-container>
                  </el-row>
                </div>
              </el-row>


              <!-- RECHERCHER DES FACTURES -->
              <el-row v-if="droitAcces.caisse_facture" :gutter="20">
                <div class="grid-content" style="padding:3px; margin:5px">
                  <el-row>
                    <v-container fluid grid-list-md>
                      <el-card class="box-card">
                        <v-form v-model="valid" ref="formFacture" lazy-validation id="formFacture">
                          <v-layout row>
                            <v-flex xs12>
                              <el-radio v-model="typeRech" label="fournisseur">Paiement fournisseur/prestataire</el-radio>
                              <el-radio v-model="typeRech" label="client">Client</el-radio>
                              <el-radio v-model="typeRech" label="fond">Décaissement</el-radio>
                              <el-radio v-model="typeRech" label="mission">Paiement mission</el-radio>
                              <!-- <el-radio v-model="typeRech" label="fond">Decaissement</el-radio> -->
                            </v-flex>
                            <!-- <v-flex xs12>
                              <el-radio v-model="typeRech" label="intervention">Paiement intervention</el-radio>
                              <el-radio v-model="typeRech" label="location">Locations</el-radio>
                            </v-flex> -->
                            </v-layout>
                          <v-layout row>
                            <v-flex md2 v-if="typeRech !='location'">
                              <el-select clearable v-model="selectTypeFacture" placeholder="Type" style="width:100%">
                                <el-option v-for="item in typeFacture" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </v-flex>
                            <v-flex md3 v-if="this.selectTypeFacture === 1 || this.selectTypeFacture === 2">
                              <el-date-picker name="dateFacture" v-model="dateFacture" :rules="dateFactureRules" type="daterange" range-separator="à" start-placeholder="Date de début" end-placeholder="Date de fin" style="width:100%" required></el-date-picker>
                            </v-flex>
                            <v-flex md2 v-if="typeRech !='location'">
                              <el-select clearable v-model="selectEtatFacture" placeholder="Etat" style="width:100%">
                                <el-option v-for="item in etatFacture" :key="item.value" :label="item.text" :value="item.value">
                                </el-option>
                              </el-select>
                            </v-flex>
                            <v-flex md4 v-if="typeRech== 'fournisseur'">
                              <el-select  clearable v-model="selectFournisseur" filterable placeholder="Fournisseur" style="width:100%">
                                <el-option v-for="item in listFournisseur" :key="item.id" :label="item.libelle" :value="item.id">
                                </el-option>
                              </el-select>
                            </v-flex>
                              <v-flex md4   v-show="typeRech== 'fond'">
                              <el-select  clearable v-model="selectDemandeur" filterable placeholder="Demandeur" style="width:100%">
                                <el-option v-for="item in listeDemandeur" :key="item.id" :label="item.value" :value="item.id">
                                </el-option>
                              </el-select>
                            </v-flex>

                            <v-flex md4 v-if="typeRech== 'client'">
                                <el-select  clearable v-model="selectClient" filterable placeholder="Client" style="width:100%">
                                  <el-option v-for="item in listClient" :key="item.id" :label="item.libelle" :value="item.id">
                                  </el-option>
                                </el-select>
                              </v-flex>

                            <v-flex md1>
                              <v-btn icons color="blue" @click="loadFacture(detailBanque)" fab dark small> <v-icon>search</v-icon></v-btn>
                            </v-flex>
                          </v-layout>

                        </v-form>
                      </el-card>
                    </v-container>
                  </el-row>
                </div>
                <br/>
              </el-row>


              <!-- RESULTATS DES RECHERCHES -->
              <el-row v-if="listFacture.length !== 0" :gutter="20">
                <div class="grid-content" style="padding:3px; margin:5px">
                  <el-row>
                    <v-container fluid grid-list-md>
                      <el-card class="box-card">

                        <!-- BTN IMPRESSION SEARCH -->
                        <!-- <v-layout row>
                            <v-spacer></v-spacer>
                            <v-flex xs2 class="text-xs-right">
                                <v-tooltip top>
                                    <v-btn   slot="activator" color="orange" @click.stop="imprimeSearchFacture(detailBanque.id)" dark>
                                        Imprimer <v-icon >print</v-icon>
                                    </v-btn>
                                    Imprimer la liste de recherche
                                </v-tooltip>
                            </v-flex>
                        </v-layout> -->

                        <data-tables ref="multipleTable" :data="listFacture" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                          <el-table-column prop="libelle" label="Libellé" width="280" fixed>
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{scope.row.libelle}}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="typeFact" label="Concerne" width="220">
                            <template slot-scope="scope">
                              <v-chip outline text-color="primary" label color="primary">
                                {{scope.row.typeFact}}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="concerne" label="Fournisseur / Demandeur" width="220"></el-table-column>
                          <el-table-column prop="etat" label="Etat" width="220">
                            <template slot-scope="scope">
                              <v-chip v-if="scope.row.etat === 'IMPAYE'" text-color="white" label color="red">
                                {{scope.row.etat}}
                              </v-chip>
                              <v-chip v-if="scope.row.etat === 'SOLDE'" text-color="white" label color="green">
                                {{scope.row.etat}}
                              </v-chip>
                              <v-chip v-if="scope.row.etat === 'EN COURS DE PAIEMENT'" text-color="white" label color="orange">
                                {{scope.row.etat}}
                              </v-chip><v-chip v-if="scope.row.etat === 'EN ATTENTE DE PAIEMENT'" text-color="white" label color="primary">
                                {{scope.row.etat}}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="total" label="Montant" width="220">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="secondary">
                                {{scope.row.total}} FCFA
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column label="Actions" width="140" fixed="right">
                            <template slot-scope="scope">
                              <v-btn v-if="droitAcces.caisse_reglement" icons color="green" @click="loadRegement(scope.row, scope.row.type)" fab dark small> <v-icon>local_atm</v-icon>
                              </v-btn>
                              <v-btn v-if="droitAcces.imprime_facture && scope.row.type != 3" icons color="orange" @click="imprimerFacture(scope.row)" fab dark small> <v-icon>print</v-icon>
                              </v-btn>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </el-card>
                    </v-container>
                  </el-row>
                </div>
                <br/>
              </el-row>


              <!-- MODAL LISTE REGLEMENT -->
              <v-dialog v-model="dialogLoadReglement"  max-width="90%" :overlay="true" scrollable persistent>
                <v-card>
                  <v-toolbar style="flex: 0 0 auto;" dark class="primary">
                    <v-toolbar-title>Liste des reglements de la facture {{factureCourant.ref}} </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="closeLoadReglement()" dark><v-icon>close</v-icon> </v-btn>
                  </v-toolbar>

                  <v-card-text>
                    <!-- TOTAL -->
                    <v-container fluid grid-list-md>
                      <v-layout row>
                        <v-flex md4>
                          <p align="center">
                            <v-chip text-color="white" label color="primary" style="font-size:18px; width:100%">
                              TOTAL A REGLER: {{totalFacture}} FCFA
                            </v-chip>
                          </p>
                        </v-flex>
                        <v-flex md4>
                          <p align="center">
                            <v-chip text-color="white" label color="green" style="font-size:18px; width:100%">
                               PAYE : {{payeFacture}} FCFA
                            </v-chip>
                          </p>
                        </v-flex>
                        <v-flex md4>
                          <p align="center">
                            <v-chip text-color="white" label color="red" style="font-size:18px; width:100%">
                               RESTANT : {{impayeFacture}} FCFA
                            </v-chip>
                          </p>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <!-- SOLDE -->
                    <p align="center">
                      <v-chip v-if="factureCourant.etatReglFact === true" outline text-color="green" label color="green" style="font-size:22px; width:100%">
                        FACTURE SOLDE <v-icon right>check</v-icon>
                      </v-chip>
                    </p>

                    <p align="center" v-if="factureCourant.etatPaiement == false">
                      <v-chip outline text-color="orange" label color="orange" style="font-size:22px; width:100%">
                        LE DERNIER PAIMENT EFFECTUER N'A PAS ENCORE ETE ENCAISSE PAR LE FOURNISSEUR <v-icon right>add_alert</v-icon>
                      </v-chip>
                    </p>
                    <div v-if="listReglement.length === 0">
                      <p align="center">
                        <v-chip outline text-color="orange" label color="orange" style="font-size:22px; width:100%">AUCUN PAIEMENT N'A ENCORE ETE EFFECTUE SUR CETTE FACTURE <v-icon right>add_alert</v-icon>
                        </v-chip>
                      </p>
                    </div>

                    <!-- BTN AJOUT REGLEMENT -->
                    <v-spacer></v-spacer>
                    <div class="text-xs-right" v-if="this.soldeCaisse !== 0 && (factureCourant.etatPaiement === null || factureCourant.etatPaiement === true) && factureCourant.etatReglFact === false && this.soldeCaisse &&  factureCourant.type != 3 && totalFacture !=0">
                      <v-tooltip top>
                        <v-btn v-if="droitAcces.edit_reglement" slot="activator" icons color="primary" @click.stop="newReglement(factureCourant, typeF)" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                        Ajouter un nouveau paiement
                      </v-tooltip>
                    </div>

                    <!-- AJOUTER REGLEMENT -->
                    <el-row :gutter="20" v-if="this.soldeCaisse != 0 && factureCourant.etatPaiement == null || factureCourant.etatPaiement == true && dialogAjoutReglement == true  && dialogEdit == false && factureCourant.etatReglFact == false && this.soldeCaisse != 0">
                      <div class="grid-content" style=" padding: 3px">
                        <el-row>
                          <el-card class="box-card">
                            <div>
                              <p align="center">
                                <v-chip v-if="dialogEdit != true" text-color="white" label color="primary" style="font-size:22px; width:100%">AJOUT D'UN NOUVEAU PAIEMENT <v-icon right>local_atm</v-icon>
                                </v-chip>
                                <v-chip v-if="dialogEdit" text-color="white" label color="primary" style="font-size:22px; width:100%">MODIFIER LE PAIEMENT PAIE-{{reglementCourant.id}} <v-icon right>local_atm</v-icon>
                                </v-chip>
                              </p>

                              <v-form v-model="valid" ref="formReglement" lazy-validation id="formReglement">
                                <v-container fluid grid-list-md>
                                  <v-layout row>
                                    <v-flex md4>
                                      <div class="block">
                                        <span class="demonstration">Montant à verser *</span>
                                        <el-input type="number" :readonly="readInput" :min="0" :max="totalFacture" name="montantVerse" placeholder="Montant à verser" v-model="montantVerse" style="width:100%"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md4>
                                      <div class="block">
                                        <span class="demonstration">Effectué par ? *</span>
                                        <el-select :disabled="readInput"  filterable v-model="selectEffectue" placeholder="Effectué par" style="width:100%">
                                          <el-option v-for="item in effectue" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </v-flex>
                                    <v-flex md4>
                                      <div class="block">
                                        <span class="demonstration">Mode de paiement *</span>
                                        <el-select  :disabled="readInput"  v-if="caisseCourant.type == 'Caisse'" filterable v-model="selectMode" placeholder="Mode de paiement" style="width:100%">
                                          <el-option v-for="item in mode" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                        <el-select v-if="caisseCourant.type == 'Banque'" filterable v-model="selectMode" placeholder="Mode de paiement" style="width:100%">
                                          <el-option v-for="item in modeBanque" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout row>
                                    <v-flex md3 v-if="selectEffectue == 2">
                                      <div class="block">
                                        <span class="demonstration">Nom du remettant *</span>
                                        <el-input name="remettant" placeholder="Nom du remettant" v-model="remettant" style="width:100%"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md3 v-if="selectMode == 2 || selectMode == 3">
                                      <div class="block">
                                        <span class="demonstration">Référence chèque *</span>
                                        <el-input name="reference" placeholder="Référence" v-model="reference" style="width:100%"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md3 v-if="selectMode == 2">
                                      <div class="block">
                                        <span class="demonstration">Encaissé ? *</span>
                                        <el-select filterable v-model="selectEncaisse" placeholder="Encaissé" style="width:100%">
                                          <el-option v-for="item in encaisse" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <br>
                                   <v-layout row v-if="selectMode == 2">
                                          <v-flex xs4 class="ml-3">
                                            <p class="font-weight-thin">Format (JPEG,PNG,PDF), 10 Mo maximum</p>
                                             <v-flex md4>
                                                <!-- <a :href="urlImage"  target=_blank> -->
                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="urlImage" alt="avatar"></v-avatar><br/>
                                                <!-- </a> -->
                                                <input name="docs" type="file" style="display:none" ref="docs" accept="image/*" @change="onFileImageLogoPicked"/>
                                                <v-btn color="primary" class="white--text" required @click.native="$refs.docs.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                                                <!-- <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div> -->
                                            </v-flex>

                                            <!-- <v-avatar :tile="true"  required size="120px" height="100px" color="grey lighten-4">
                                              <img :src="urlImage" alt="avatar" />
                                            </v-avatar> -->
                                            <!-- <v-layout row>
                                              <input
                                                name="docs"
                                                type="file"
                                                style="display:none"
                                                ref="file"
                                                accept="image/*|pdf"
                                                @change="onFileImagePicked"
                                              />
                                              <v-btn
                                                color="primary"
                                                class="white--text"
                                                required
                                                @click.native="$refs.file.click()"
                                              >
                                                Document
                                                <v-icon right dark>cloud_upload</v-icon>
                                              </v-btn>
                                            </v-layout> -->
                                          </v-flex>
                                   </v-layout>

                                  <v-btn @click.stop="closeLoadReglement()" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                                  <v-btn icons color="blue" @click="validBanquPaiem = true" :disabled="!valid" dark>Enregistré <v-icon right>save</v-icon></v-btn>
                                </v-container>
                              </v-form>
                            </div>
                          </el-card>
                        </el-row>
                      </div>
                      <br/>
                    </el-row>

                    <!-- EDIT REGLEMENT -->
                    <el-row :gutter="20" v-if="dialogEdit === true && dialogEditReglement === true">
                      <div class="grid-content" style=" padding: 3px">
                        <el-row>
                          <el-card class="box-card">
                            <div>
                              <p align="center">
                                <v-chip v-if="dialogEdit" text-color="white" label color="primary" style="font-size:22px">MODIFIER LE PAIEMENT PAIE-{{reglementCourant.id}} <v-icon right>local_atm</v-icon>
                                </v-chip>
                              </p>

                              <v-form v-model="valid" ref="formReglement" lazy-validation id="formReglement">
                                <v-container fluid grid-list-md>
                                  <v-layout row>
                                    <v-flex md4>
                                      <div class="block">
                                        <span class="demonstration">Montant à verser *</span>
                                        <el-input type="number" :min="0" :max="impayeFacture1" name="montantVerse" placeholder="Montant à verser" v-model="montantVerse" style="width:100%"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md4>
                                      <div class="block">
                                        <span class="demonstration">Effectué par ? *</span>
                                        <el-select filterable v-model="selectEffectue" placeholder="Effectué par" style="width:100%">
                                          <el-option v-for="item in effectue" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </v-flex>
                                    <v-flex md4>
                                      <div class="block">
                                        <span class="demonstration">Mode de paiement *</span>
                                        <el-select filterable v-model="selectMode" placeholder="Mode de paiement" style="width:100%">
                                          <el-option v-for="item in mode" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout row>
                                    <v-flex md3 v-if="selectEffectue == 2">
                                      <div class="block">
                                        <span class="demonstration">Nom du remettant *</span>
                                        <el-input name="remettant" placeholder="Nom du remettant" v-model="remettant" style="width:100%"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md3 v-if="selectMode == 2 || selectMode == 3">
                                      <div class="block">
                                        <span class="demonstration">Banque / Réseau mobile *</span>
                                        <el-input name="banque" placeholder="Banque / Réseau mobile" v-model="banque" style="width:100%"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md3 v-if="selectMode == 2 || selectMode == 3">
                                      <div class="block">
                                        <span class="demonstration">Référence *</span>
                                        <el-input name="reference" placeholder="Référence" v-model="reference" style="width:100%"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md3 v-if="selectMode == 2">
                                      <div class="block">
                                        <span class="demonstration">Encaissé ? *</span>
                                        <el-select filterable v-model="selectEncaisse" placeholder="Encaissé" style="width:100%">
                                          <el-option v-for="item in encaisse" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                   <br>
                                   <v-layout row v-if="selectMode == 2">
                                          <v-flex xs4 class="ml-3">
                                            <p class="font-weight-thin">Format (JPEG,PNG,PDF), 10 Mo maximum</p>
                                            <v-avatar :tile="true"  required size="120px" height="100px" color="grey lighten-4">
                                              <img :src="urlImage" alt="avatar" />
                                            </v-avatar>
                                            <v-layout row>
                                              <input
                                                name="docs"
                                                type="file"
                                                style="display:none"
                                                ref="file"
                                                accept="image/*|pdf"
                                                @change="onFileImagePicked"
                                              />
                                              <v-btn
                                                color="primary"
                                                class="white--text"
                                                required
                                                @click.native="$refs.file.click()"
                                              >
                                                Document
                                                <v-icon right dark>cloud_upload</v-icon>
                                              </v-btn>
                                            </v-layout>
                                          </v-flex>
                                   </v-layout>

                                  <v-btn @click.stop="dialogEditReglement = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                                  <v-btn icons color="blue" @click="submitReglement()" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                                </v-container>
                              </v-form>
                            </div>
                          </el-card>
                        </el-row>
                      </div>
                      <br/>
                    </el-row>

                    <!-- LISTE REGLEMENT -->
                    <el-row :gutter="20" v-if="listReglement.length !== 0">
                      <div class="grid-content" style=" padding: 3px">
                        <el-row>
                          <el-card class="box-card">
                            <div>
                              <data-tables ref="multipleTable" :data="listReglement" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                                <el-table-column prop="ref" label="Référence" width="280" fixed>
                                  <template slot-scope="scope">
                                    <v-chip text-color="white" label color="primary">
                                      {{scope.row.ref}}
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="etat" label="Etat" width="220">
                                  <template slot-scope="scope">
                                    <v-chip v-if="scope.row.etat === false" text-color="white" label color="red">
                                      IMPAYE
                                    </v-chip>
                                    <v-chip v-else text-color="white" label color="green">
                                      PAYE
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="montant" label="Montant" width="240">
                                  <template slot-scope="scope">
                                    <v-chip text-color="white" label color="secondary">
                                      {{scope.row.montant}} FCFA
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="date" label="Date de paiement" width="240">
                                  <template slot-scope="scope">
                                    <v-chip text-color="white" label color="secondary">
                                      {{scope.row.date}}
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column label="Actions" width="240">
                                  <template slot-scope="scope">
                                    <v-btn v-if="droitAcces.show_reglement" icons color="green" @click="showReglement(scope.row)" fab dark small> <v-icon>folder_open</v-icon>
                                    </v-btn>
                                    <v-btn v-if="droitAcces.edit_reglement && scope.row.etat === false" icons color="primary" @click="editRegement(scope.row)" fab dark small> <v-icon>edit</v-icon>
                                    </v-btn>
                                     <v-btn  icons color="indigo" @click="showPieceJustifi(scope.row)"  fab dark small> <v-icon>photo_camera</v-icon>
                                    </v-btn>
                                    <v-btn v-if="droitAcces.imprime_reglement" icons color="orange" @click="imprimerReglement(scope.row)" fab dark small> <v-icon>print</v-icon>
                                    </v-btn>
                                  </template>
                                </el-table-column>
                              </data-tables>
                            </div>
                          </el-card>
                        </el-row>
                      </div>
                      <br/>
                    </el-row>

                    <v-tooltip top>
                      <v-btn slot="activator" icons color="orange" @click.stop="closeLoadReglement()" dark>Fermer <v-icon right>close</v-icon></v-btn>
                      Fermer
                    </v-tooltip>
                  </v-card-text>
                  <div style="flex: 1 1 auto;"></div>
                </v-card>
              </v-dialog>


              <v-layout row>
                <v-flex md12 xs12>
                  <p align="center">
                    <v-chip icons text-color="white" label color="primary" style="font-size:19px; width:100%">
                      APPROVISIONNEMENTS VALIDE PAR LE DG <v-icon right>get_app</v-icon>
                    </v-chip>
                  </p>
                </v-flex>
              </v-layout>
              <!-- TABLEAU DES APPROS VALIDER PAR CHEQUE -->
              <v-layout row>
                <v-flex md12 xs12>
                  <data-tables ref="multipleTable" :data="listApproDgCheq" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                    <el-table-column prop="dateDmd" label="Date demande" width="280" fixed>
                      <template slot-scope="scope">
                        <v-chip text-color="white" label color="primary">
                          {{scope.row.dateDmd}}
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="dateValid" label="Date validation" width="220">
                      <template slot-scope="scope">
                        <v-chip outline text-color="primary" label color="primary">
                          {{scope.row.dateValid}}
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="montant" label="Montant (CFA)" width="220"></el-table-column>
                    <el-table-column prop="caisseLibelle" label="Tresorerie" width="220"></el-table-column>
                    <el-table-column label="Actions" width="140" fixed="right">
                      <template slot-scope="scope">
                        <v-btn icons color="green" @click="loadDialogConfirm(scope.row)" fab dark small> <v-icon>local_atm</v-icon>
                        </v-btn>
                        <!-- <v-btn icons color="orange" @click="imprimerFacture(scope.row)" fab dark small> <v-icon>print</v-icon>
                        </v-btn> -->
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>
              </v-layout>

              <!-- LISTE DES APPRO BANQUE -->
              <el-row :gutter="20">
                <div class="grid-content" style="padding:3px; margin:5px">
                  <p align="center">
                    <v-chip icons text-color="white" label color="primary" style="font-size:19px; width:100%">
                      HISTORIQUE DES APPROVISIONNMENTS <v-icon right>get_app</v-icon>
                    </v-chip>
                  </p>
                  <el-row>
                    <v-container fluid grid-list-md>
                      <el-card class="box-card">

                        <!-- BTN IMPRESSION HISTO -->
                        <v-layout row>

                            <v-flex xs12>
                              <v-chip text-color="white" label color="green" style="font-size:12px; width:100%">
                                MONTANT TOTAL DES APPROVISIONNEMENTS: {{montantEntree}} FCFA
                              </v-chip>
                            </v-flex>

                            <v-spacer></v-spacer>
                            <v-flex xs2 class="text-xs-right">
                                <v-tooltip top>
                                    <v-btn   slot="activator" color="orange" @click.stop="imprimeHistoBanque(detailBanque.id)" dark>
                                        Imprimer <v-icon >print</v-icon>
                                    </v-btn>
                                    Imprimer l'historique des approvisionnements
                                </v-tooltip>
                            </v-flex>
                        </v-layout>

                        <data-tables ref="multipleTable" :data="listApproBanque" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                          <el-table-column prop="motif" label="Libellé" width="280" fixed>
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{scope.row.motif}}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="etat" label="Etat" width="220">
                            <template slot-scope="scope">
                              <v-chip v-if="scope.row.valide === 0" outline text-color="green" label color="green">
                                EN ATTENTE DE VALIDATION
                              </v-chip>
                              <v-chip v-else-if="scope.row.valide === 1" outline text-color="primary" label color="primary">
                                VALIDER PAR LE DG
                              </v-chip>
                              <v-chip v-else-if="scope.row.valide === 2" text-color="white" label color="red">
                                REFUSER PAR LE DG
                              </v-chip>
                              <v-chip v-if="scope.row.status === 0" text-color="white" label color="primary">
                                EN COURS DE TRAITEMENT
                              </v-chip>
                              <v-chip v-else-if="scope.row.status === 1" text-color="white" label color="red">
                                TRAITEMENT TERMINE
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="validateur" label="En charge de valider" width="220"></el-table-column>
                          <el-table-column prop="montant" label="Montant" width="220">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="secondary">
                                {{scope.row.montant}} FCFA
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column label="Actions" width="140" fixed="right">
                            <template slot-scope="scope">
                              <v-btn
                                class="tooltip-btn"
                                title="Détails"
                               icons color="green" @click="showAppro(scope.row)" fab dark small> <v-icon>folder_open</v-icon>
                              </v-btn>
                              <!-- <v-btn v-if="scope.row.valide === 0" icons color="green" @click="newValideAppro(scope.row)" fab dark small> <v-icon>done_all</v-icon>
                              </v-btn> -->
                              <v-btn
                                class="tooltip-btn"
                                title="Modifier"
                               v-if="scope.row.valide === 0 && scope.row.etat === false" icons color="primary" @click="editAppro(scope.row)" fab dark small> <v-icon>edit</v-icon>
                              </v-btn>
                              <v-btn
                                class="tooltip-btn"
                                title="Imprimer"
                               icons color="orange" @click="imprimerAppro(scope.row)" fab dark small> <v-icon>print</v-icon>
                              </v-btn>
                              <v-tooltip top>
                                <v-btn
                                class="tooltip-btn"
                                title="Supprimer"
                                 v-if="scope.row.valide === 0"  slot="activator" @click.stop="dialogSuprAppro = true; idAppro = scope.row.id;" fab dark small color="red">
                                  <v-icon dark>delete</v-icon>
                                </v-btn>
                                Supprimer
                              </v-tooltip>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </el-card>
                    </v-container>
                  </el-row>
                </div>
                <br/>
              </el-row>

              <!-- HISTORIQUE DES OPERATIONS -->
              <el-row :gutter="20">
                <div class="grid-content" style="padding:3px; margin:5px">
                  <p align="center">
                    <v-chip icons text-color="white" label color="primary" style="font-size:19px; width:100%">
                      HISTORIQUE DES 30 DERNIERES OPERATIONS <v-icon right>get_app</v-icon>
                    </v-chip>
                  </p>
                  <el-row>
                    <v-container fluid grid-list-md>
                      <el-card class="box-card">

                      <!-- BTN IMPRESSION -->
                      <!-- <v-layout row>
                          <v-spacer></v-spacer>
                          <v-flex xs2 class="text-xs-right">
                              <v-tooltip top>
                                  <v-btn   slot="activator" color="orange" @click.stop="imprimeAllTresorerie()" dark>
                                      Imprimer <v-icon >printer</v-icon>
                                  </v-btn>
                                  Imprimer la liste de la tresorerie
                              </v-tooltip>
                          </v-flex>
                      </v-layout> -->

                  <!-- RECHERCHER DES FACTURES -->
                  <el-row :gutter="20">
                    <div class="grid-content" style="padding:3px; margin:5px">
                      <el-row>
                        <v-container fluid grid-list-md>
                          <el-card class="box-card">
                            <v-form ref="formOperation" lazy-validation id="formOperation">
                              <v-layout row>
                                <v-flex md6>
                                  <el-date-picker name="dateOperation" v-model="dateOperation" :rules="dateOperationRules" type="daterange" range-separator="-" start-placeholder="Date de début" end-placeholder="Date de fin" style="width:100%" required></el-date-picker>
                                </v-flex>
                                <!-- <v-flex md4>
                                  <el-select clearable v-model="selectFournisseur" filterable placeholder="Fournisseur" style="width:100%">
                                    <el-option v-for="item in listFournisseur" :key="item.id" :label="item.libelle" :value="item.id">
                                    </el-option>
                                  </el-select>
                                </v-flex> -->
                                <v-flex md3>
                                  <el-dropdown size="small" split-button type="primary" @command="handleCommand" @click="handleClick" >
                                    recherche
                                    <el-dropdown-menu slot="dropdown" >
                                      <el-dropdown-item command="all">Afficher toutes les transactions</el-dropdown-item>
                                    </el-dropdown-menu>
                                  </el-dropdown>
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </el-card>
                        </v-container>
                      </el-row>
                    </div>
                    <br/>
                  </el-row>

                  <!-- BTN IMPRESSION -->
                  <v-layout row>

                      <!--<v-flex xs1 >-->
                          <!--<v-tooltip top>-->
                              <!--<v-btn   slot="activator" :disabled="disabledBtn" color="orange" small @click.stop="imprimeListeHisPDF()" dark>-->
                                  <!--Imprimer <v-icon >printer</v-icon>-->
                              <!--</v-btn>-->
                              <!--Imprimer la liste des transactions-->
                          <!--</v-tooltip>-->
                      <!--</v-flex>-->

                      <v-flex xs3 >
                        <el-col :span="2" >
                          <el-popover
                              ref="popover5"
                              placement="top"
                              width="180"
                              trigger="hover">
                            <p>Veuillez choisir le format d'impression ?</p>
                            <div style="text-align: right; margin: 0">
                              <el-button type="success" size="mini" @click="imprimeListeHis('PDF')">PDF</el-button>
                              <el-button type="primary" size="mini" @click="imprimeListeHis('EXC')">EXCEL</el-button>
                            </div>
                          </el-popover>
                          <div>
                            <el-button v-popover:popover5 type="warning" :disabled="disabledBtn"
                                      icon="el-icon-printer" >Imprimer la liste
                            </el-button>
                          </div>
                        </el-col>
                      </v-flex>

                      <v-flex xs3>
                        <v-chip text-color="white" label color="green" style="font-size:12px; width:100%">
                        TOTAL ENTREE: {{totalEntree}} FCFA
                      </v-chip>
                      </v-flex>

                      <v-flex xs3>
                        <v-chip text-color="white" label color="red" style="font-size:12px; width:100%">
                        TOTAL SORTIE: {{totalSortie}} FCFA
                      </v-chip>
                      </v-flex>

                      <v-flex xs3>
                        <v-chip text-color="white" label color="primary" style="font-size:13px; width:100%">
                        SOLDE: {{detailBanque.solde}} FCFA
                      </v-chip>
                      </v-flex>
                  </v-layout>


                        <data-tables ref="multipleTable1" :data="listOperation" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width: 100%">
                          <el-table-column prop="ref" label="ID" width="150" fixed>
                          </el-table-column>
                          <el-table-column prop="date" label="Date" width="150" fixed>
                          </el-table-column>
                          <el-table-column prop="libelle" label="Libellé" width="280" fixed>
                          </el-table-column>
                          <el-table-column prop="initiateur" label="Initiateur" width="220">
                          </el-table-column>
                          <el-table-column prop="validateur" label="Validateur" width="220">
                          </el-table-column>

                            <el-table-column label="OPERATION">
                              <el-table-column
                                prop="entree"
                                label="ENTREE"
                                width="120">
                            </el-table-column>
                              <el-table-column
                                prop="sortie"
                                label="SORTIE"
                                width="120">
                              </el-table-column>
                            </el-table-column>

                          <el-table-column prop="solde" label="Solde" width="220">
                          </el-table-column>
                        </data-tables>
                      </el-card>
                    </v-container>
                  </el-row>
                </div>
                <br/>
              </el-row>

               <!-- MODAL SHOW REGLEMENT -->
                  <v-dialog v-model="dialogShowReglement" max-width="70%" :overlay="true" scrollable persistent>
                    <v-card>
                      <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                        <v-toolbar-title>Détails du reglement {{detailReglement.ref}} de la facture {{detailReglement.refFact}} </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="dialogShowReglement = false" dark><v-icon>close</v-icon> </v-btn>
                      </v-toolbar>

                      <v-card-text>
                        <el-row :gutter="20">
                          <div class="grid-content" style=" padding: 3px">
                            <el-row>
                              <el-card class="box-card">
                                <div class="grid-content bg-purple">
                                  <div class="text item">
                                    <v-layout row justify>
                                      <v-flex md6>
                                        <p><b>Identifiant : </b> {{detailReglement.ref}} </p>
                                        <p><b>Facture : </b> {{detailReglement.refFact}} </p>
                                        <p><b>Banque : </b> {{detailReglement.caisse}} </p>
                                        <p><b>Montant : </b>
                                          <v-chip text-color="white" label color="primary">
                                            {{detailReglement.montant}} FCFA
                                          </v-chip>
                                        </p>
                                        <p><b>Etat : </b>
                                          <v-chip v-if="detailReglement.etat" text-color="white" label color="red">
                                            PAYE
                                          </v-chip>
                                          <v-chip v-if="!detailReglement.etat" text-color="white" label color="green">
                                            IMPAYE
                                          </v-chip>
                                        </p>
                                        <p><b>Mode de paiement : </b>
                                          <v-chip v-if="detailReglement.mode === 1" outline text-color="primary" label color="primary">
                                            Espèce
                                          </v-chip>
                                          <v-chip v-else-if="detailReglement.mode === 2" outline text-color="primary" label color="primary">
                                            Chèque
                                          </v-chip>
                                          <v-chip v-else-if="detailReglement.mode === 3" outline text-color="primary" label color="primary">
                                            Mobile money
                                          </v-chip>
                                        </p>
                                        <p v-if="detailReglement.banque !== null"><b>Banque / Réseau mobile : </b> {{detailReglement.banque}}</p>
                                      </v-flex>
                                      <v-flex md6>
                                        <p v-if="detailReglement.reference !== null"><b>Référence : </b> {{detailReglement.reference}}</p>
                                        <p><b>Paiement : </b>
                                          <v-chip v-if="detailReglement.partiel === true" text-color="white" label color="orange">
                                            PARTIEL
                                          </v-chip>
                                          <v-chip v-else-if="detailReglement.partiel === false" text-color="white" label color="green">
                                            TOTAL
                                          </v-chip>
                                        </p>
                                        <p><b>Date du paiement : </b> {{detailReglement.date}}</p>
                                        <p><b>Récuperé par : </b>
                                          <v-chip v-if="detailReglement.effectue === 1" text-color="white" label color="secondary">
                                            {{detailReglement.concerne}}
                                          </v-chip>
                                          <v-chip v-else-if="detailReglement.effectue === 2" text-color="white" label color="secondary">
                                            {{detailReglement.remettant}}
                                          </v-chip>
                                        </p>
                                        <p><b>Enregistré par : </b> {{detailReglement.userCreated}} </p>
                                        <p><b>Date d'enregistrement : </b> {{detailReglement.created}} </p>
                                        <p><b>Date de modification : </b> {{detailReglement.modified}} </p>
                                         <p>
                                          <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="detailReglement.urlImage" alt="avatar"/></v-avatar>
                                         </p>
                                      </v-flex>
                                    </v-layout>
                                  </div>
                                </div>
                              </el-card>
                            </el-row>
                          </div>
                          <br/>
                        </el-row>

                        <v-tooltip top>
                          <v-btn slot="activator" icons color="orange" @click.stop="dialogShowReglement = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                          Fermer
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn v-if="detailReglement.etat === false" slot="activator" icons color="primary" @click.stop="editRegement(detailReglement);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
                          Modifier
                        </v-tooltip>

                      </v-card-text>
                      <div style="flex: 1 1 auto;"></div>
                    </v-card>
                  </v-dialog>

      <!-- MODAL PAIEMENT -->
        <v-dialog v-model="validBanquPaiem" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
              <h1 align="center">Voulez-vous vraiment effectuer un paiement d'un montant de  {{new Intl.NumberFormat().format(this.montantVerse)}} FCFA</h1>
              <p align="center">
                <v-btn @click.native="validBanquPaiem = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                <v-btn icons color="red"  @click="submitReglement()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
              </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>

              <!-- MODAL CONFIRMATION APPRO VALIDER PAR DG -->
              <v-dialog v-model="dialogConfirmCheq" max-width="50%" persistent :overlay="true" scrollable :loading="loading">
                  <v-card>
                      <v-toolbar card dark color="primary">
                          <v-toolbar-title>Confirmation de l'approvisionnement</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn icon dark @click.native="dialogConfirmCheq = false"> <v-icon>close</v-icon></v-btn>
                      </v-toolbar>

                      <v-card-text>
                          <v-card-text>
                            <!-- <v-layout row>
                              <v-flex md6 sm12>
                                <v-chip outline text-color="primary" label color="primary">
                                    DATE DEMANDE :
                                </v-chip>
                              </v-flex>

                              <v-flex md6 sm12>
                                <v-chip outline text-color="primary" label color="primary">
                                    DATE DEMANDE :
                                </v-chip>
                              </v-flex>
                            </v-layout> -->

                              <!-- FORM VALIDATION CHEQUE COMPLETE DOCS -->
                              <v-container fluid grid-list-md>
                                <el-form label-position="top" ref="formValidCheq" :rules="rules" :model="formValidCheq" id="formValidCheq" class="demo-ruleForm">
                                    <v-layout row>
                                      <v-flex md6>
                                        <div class="block">
                                          <span class="demonstration">Numéro de chèque</span>
                                          <el-form-item prop="numCheq">
                                            <el-input name="numCheq" placeholder="Numéro de chèque" v-model="formValidCheq.numCheq"></el-input>
                                          </el-form-item>
                                        </div>
                                      </v-flex>
                                      <v-flex md6>
                                        <div class="block">
                                          <span class="demonstration">Date de signature</span>
                                          <el-form-item prop="dateSign">
                                            <el-date-picker v-model="formValidCheq.dateSign" name="dateSign" value-format="dd-MM-yyyy"
                                            type="datetime" placeholder="Date de signature" style="width: 100%"></el-date-picker>
                                          </el-form-item>
                                        </div>
                                      </v-flex>
                                    </v-layout>

                                    <p align="center">
                                      <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                        JOINDRE DES FICHIERS
                                      </v-chip>
                                    </p>

                                    <v-layout row>
                                      <v-flex xs2 class="mr-1">
                                          <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                          <v-layout row>
                                              <input name="image1" type="file" style="display:none" ref="file1" accept="image/*" @change="onFileImage1Picked"/>
                                                  <v-btn color="primary" class="white--text" required @click.native="$refs.file1.click()">Docs <v-icon right dark>cloud_upload</v-icon></v-btn>
                                                  <div class="font-weight-thin" >Joindre le chèque au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div>
                                          </v-layout>
                                      </v-flex>
                                    </v-layout>

                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn icons color="orange" @click="dialogConfirmCheq = false; idBanqueCourant = ''; resetForm('formValidCheq')" dark>Annuler <v-icon right>close</v-icon></v-btn>
                                      <v-btn icons color="primary" @click="submitValidForm('formValidCheq')" dark>Confirmer <v-icon right>close</v-icon></v-btn>
                                    </v-card-actions>
                                </el-form>
                              </v-container>

                          </v-card-text>
                      </v-card-text>
                      <div style="flex: 1 1 auto;"></div>
                  </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- MODAL AJOUT PIECE JUSTIFICATIVE -->
     <v-dialog v-model="dialogShowPiece" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Ajouter une piece justificative</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowPiece = false;showButtonPiece=false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-form v-model="valid" ref="formPieceJointe" lazy-validation id="formPieceJointe">
                      <v-layout row justify>
                          <v-flex md12>
                            <p class="font-weight-thin" >Format (JPEG,PNG,PDF), 10 Mo maximum</p>
                              <a :href="pieceJusti" target="_blank">
                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="pieceJusti" alt="avatar"></v-avatar><br/>
                            </a>
                              <input name="photo" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFilepiceJutiPicked"/>
                                <v-btn v-if="showButtonPiece==true" color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Document  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                          </v-flex>
                        </v-layout>
                       </v-form>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShowPiece = false;showButtonPiece=false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="showButtonPiece === false" slot="activator" icons color="primary" @click.stop="showButtonPiece=true" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="showButtonPiece === true" slot="activator" icons color="primary" @click.stop="savePieceJointe();" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
            Enregistrer
          </v-tooltip>

        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

      <!-- MODAL TRANSFERT CAISSE -->
          <v-dialog v-model="dialogAjoutTrans" max-width="45%" :overlay="true" scrollable persistent>
            <v-card>
              <v-toolbar style="flex: 0 0 auto;" dark class="primary">
                <v-toolbar-title>
                  <span>Transferer des fonds dans une autre trésorerie</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="dialogAjoutTrans = false" dark><v-icon>close</v-icon> </v-btn>
              </v-toolbar>

              <v-card-text>
                <el-form :model="transFertForm" :rules="rulesTransfer" ref="transFertForm" id="transFertForm" label-width="120px" class="demo-ruleForm">
                  <el-form-item label="Le montant" prop="montantTransf">
                    <el-input type="number" name="montantTransf" v-model="transFertForm.montantTransf"></el-input>
                  </el-form-item>
                  <el-form-item label="Caisse concerne" prop="caisse">
                      <el-select filterable style="width: 100%"   v-model="transFertForm.caisseSelect" placeholder="Selectionner une caisse">
                          <el-option
                          v-for="item in listCaisse"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="Le motif" prop="motif">
                    <el-input
                            type="textarea"
                            name="libelleTransfert"
                            :rows="5"
                            placeholder="Presenter le motif"
                            v-model="transFertForm.libelleTransfert">
                    </el-input>
                  </el-form-item>

                  <el-form-item class="text-xs-right">
                    <v-btn color="grey"  @click="ClearTransfertForm" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                    <v-btn icons dark color="green" @click="submitTransferCaisse('transFertForm')">Enregistrer<v-icon right>add</v-icon></v-btn>
                  </el-form-item>
                </el-form>
              </v-card-text>

              <div style="flex: 1 1 auto;"></div>
            </v-card>
          </v-dialog>


        <v-tooltip top>
          <v-btn slot="activator" icons color="orange" dark>Fermer <v-icon right>close</v-icon></v-btn>
          Fermer
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" @click.stop="newAppro(detailBanque);" icons color="indigo" dark>Appro banque <v-icon right>get_app</v-icon></v-btn>
          Approvisionner la banque
        </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" icons color="grey" @click.stop="newTransfert(detailBanque);" dark>Transfert <v-icon right>transfer_within_a_station</v-icon></v-btn>
            Tranfert de fond dans une autre trésorerie
          </v-tooltip>
      </v-card-text>
      <div style="flex: 1 1 auto;"></div>

    </v-card>
</template>


<script>
  var echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/bar')
  require('echarts/lib/chart/pictorialBar')
  require('echarts/lib/chart/funnel')
  require('echarts/lib/chart/sankey')
  require('echarts/lib/chart/scatter')
  require('echarts/lib/chart/pie')
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  import Loading from '@/components/Loading';

  export default {
    components:{ Loading },
    name: 'ModalBanque',
    props:["listApproDgCheq","statCaisse2","dialogModalBanque", "detailBanque","montantEntree","montantSortie","tableOpera","formRech","searchOpera",
            "approCourant","newAppro","dialogAjoutAppro","listApproBanque", "showAppro", "imprimeHistoBanque", "editAppro", "imprimerAppro",
            "handleCommand", "handleClick", "disabledBtn", "listOperation", "dateOperation", "totalEntree", "totalSortie","imprimeListeHis"],
    data () {
      return {

        loading: false,
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

        //STATISTIQUE
        statAllCaisse: [],
        statBanque: [],
        // listApproDgCheq: [],
        fileCheque: [{name: '', url: ''}],
        dialogConfirmCheq: false,
        idBanqueCourant: '',
        detailReglement:[],
        dialogEdit: false,
        validBanquPaiem: false,
        dialogShowPiece: false,
        showButtonPiece: false,
        pieceJusti: "/static/img-doc.png",
        optionPaiement: '',



        selectValidateurAppro: '',

        dateFactureRules: [ (v) => !!v || "Veuillez renseigner les intervalles de date" ],
        dateOperationRules: [ (v) => !!v || "Veuillez renseigner les intervalles de date" ],
        formValidCheq: {
          numCheq: '',
          dateSign:'',
          pieceJointe:'',
        },
          rulesTransfer: {
            caisse: [
                { required: true, message: 'Veuillez selectionner une caisse', trigger: 'blur' },
            ],
            libelleTransfert: [
                { required: true, message: 'Veuillez saisir le motif', trigger: 'blur' },
            ],
            montantTransf: [
                { required: true, message: 'Veuillez saisir le montant', trigger: 'blur' },
            ],
        },
        rules: {
          numCheq: [
            { type:'string', required: true, message: 'Ce champs est obligatoire', trigger: 'blur' },
          ],
          dateSign: [
            { type: 'string', required: true, message: 'Ce champs est obligatoire'}
          ],
        },
        approForm: {
          motif: '',
          montant: '',
        },
        rulesAppro: {
          motif: [
            { required: true, message: 'Veuillez saisir le motif', trigger: 'blur' },
          ],
          montant: [
            { required: true, message: 'Veuillez saisir le montant', trigger: 'blur' },
          ],
        },
        image1: "/static/img-doc.png",
        image2: "/static/img-doc.png",
        image3: "/static/img-doc.png",
        image4: "/static/img-doc.png",
        urlImage: "/static/doc.png",

        file1: "",
        file2: "",
        file3: "",
         selectTypeFacture: "",
        typeFacture: [
          { text: 'Par date de création', value: 1 },
          { text: 'Par période', value: 2 },
        ],
        selectEtatFacture: "",
        etatFacture: [
          { text: 'Impayé', value: 0 },
          { text: 'Soldé', value: 1 },
          { text: 'En attente de paiement', value: 2 },
          { text: 'En cours de paiement', value: 3 },
        ],
        listFournisseur: [],
        selectFournisseur: "",
        listFacture: [],
        listClient: [],
        listCaisse:[],
        selectClient: "",


        totalFacture: 0,
        totalFacture1: 0,
        payeFacture: 0,
        payeFacture1: 0,
        impayeFacture: 0,
        impayeFacture1: 0,
        factureCourant: [],
        listReglement: [],
        montantVerse: 5,
        remettant: '',
        banque: '',
        reference: '',
        selectEncaisse: '',
        encaisse: [
          { text: 'OUI', value: 1 },
          { text: 'NON', value: 2 },
        ],
        selectEffectue: "",
        effectue: [
          { text: 'Lui même', value: 1 },
          { text: 'Autre', value: 2 },
        ],
        selectMode: '',
        mode: [
          { text: 'Chèque', value: 1 },
          // { text: 'Mobile money', value: 3 },
        ],
        modeBanque: [
          // { text: 'Espèce', value: 1 },
          { text: 'Chèque', value: 2 },
          // { text: 'Mobile money', value: 3 },
        ],
        caisseCourant: [],
        valid: true,
        typeRech: "fournisseur",
        //Demandeur
        selectDemandeur: null,
        listeDemandeur: [],
        dialogAjoutReglement: false,
        dialogEditReglement: false,
        dialogShowReglement: false,
        dialogShow: false,
        readInput: false,
        // Reglement facture/mission/fournissseur
        dialogLoadReglement: false,
        soldeCaisse: 0,
        reglementCourant: [],
        dialogAjoutTrans:false,
         transFertForm: {
            libelleTransfert : '',
            montantTransf: '',
            caisseSelect: '',
          }

      }
    },
    computed: {

    },
    methods: {

 submitTransferCaisse (formName) {
                if(this.detailBanque.solde1 >= this.transFertForm.montantTransf) {
                        this.loading = true
                        var form = document.getElementById('transFertForm')
                        var data = new FormData(form)
                        data.append('idUser', this.user.id)
                        data.append('caisseCrediter', this.transFertForm.caisseSelect)
                        let url = this.domaine + 'caisse/' + this.detailBanque.id + '/new/transfert/caisse'
                        this.$http.post(url, data).then(response => {
                            if (response.body) {
                                let verif = response.body
                                this.dialogAjoutTrans = false
                                if (verif.code === 1) {
                                    this.$notify({
                                          title: 'ENREGISTREMENT REUSSI',
                                          message: 'Transfert dans une autre trésorerie enregistré avec succès.',
                                          type: 'success',
                                          position: 'top-center'
                                      })
                                    this.dialogAjoutAppro = false
                                    this.showBanque(this.detailBanque.id)
                                    this.loading = false
                                } else if (verif.code === 0) {
                                    this.$message.error(verif.message)
                                    this.loading = false
                                }
                            } else {
                                this.$message.error('Erreur serveur')
                                this.loading = false
                            }
                        },
                        response => {
                            this.$message.error('Erreur serveur')
                            this.loading = false
                        })
                    }else{
                        this.$message.error("Montant à transferer est supérieur au solde de la caisse.")
                    }
            },

    newTransfert(ligne) {
              this.loading = false
              this.dialogAjoutTrans = true
              this.transFertForm ={}
            },
      loadDialogConfirm (item) {
        this.dialogConfirmCheq = true
        this.idBanqueCourant = item.id
      },
      loadClient() {
            this.loading = true
            let url = this.domaine + 'client/projet/index'
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.listClient = response.body.client
                    this.loading = false
                }
            }, error => {
                this.loading = false
            })
        },
      //STATISTIQUE
      statAllbilan () {
        //somme des entrée et des sorties
        let optionAllBilan = {
          title: {
            text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DES TRESORERIES',
            subtext: '',
            left: 'center'
          },
          color: ['#67C23A', '#e5323e'],
          tooltip : {
            trigger: 'axis',
            axisPointer : {
              type : 'shadow'
            }
          },
          legend: {
            data:[]
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis : [{
            type : 'category',
            data : []
          }],
          yAxis : [{ type : 'value' }],
          series : [
            {
              name:'Montant entrée ',
              type:'bar',
              barWidth : 30,
              data:[]
            },
            {
              name:'Montant sortie ',
              type:'bar',
              barWidth : 30,
              data:[]
            }
          ]
        }

        this.statAllCaisse.forEach(function(element) {
          optionAllBilan.xAxis[0].data.push(element.date);
          optionAllBilan.series[0].data.push(element.entree)
          optionAllBilan.series[1].data.push(element.sortie)
        })

        let chartAllBilan = echarts.init(document.getElementById('chartAllBilan'))
        chartAllBilan.setOption(optionAllBilan)
      },
      statAllbilanBanque () {
        //somme des entrée et des sorties
        let optionAllBilanBanque = {
          title: {
            text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DE LA BANQUE',
            subtext: '',
            left: 'center'
          },
          color: ['#67C23A', '#e5323e'],
          tooltip : {
            trigger: 'axis',
            axisPointer : {
              type : 'shadow'
            }
          },
          legend: {
            data:[]
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis : [{
            type : 'category',
            data : []
          }],
          yAxis : [{ type : 'value' }],
          series : [
            {
              name:'Montant entrée ',
              type:'bar',
              barWidth : 30,
              data:[]
            },
            {
              name:'Montant sortie ',
              type:'bar',
              barWidth : 30,
              data:[]
            }
          ]
        }
        this.statCaisse2.forEach(function(element) {
          optionAllBilanBanque.xAxis[0].data.push(element.date);
          optionAllBilanBanque.series[0].data.push(element.entree)
          optionAllBilanBanque.series[1].data.push(element.sortie)
        })

        let chartAllBilanBanque = echarts.init(document.getElementById('chartAllBilanBanque'))
        chartAllBilanBanque.setOption(optionAllBilanBanque)
        },
      onFileImage1Picked(event){
        const files = event.target.files
        let filename = files[0].name
        if (filename.lastIndexOf(".") <= 0)
        {
            return alert("Veuillez selectionner un  format de fichier valide ")
        }

        const fileReader = new FileReader()
        fileReader.addEventListener("load", () => {
            this.image1 = fileReader.result
        })

        fileReader.readAsDataURL(files[0])
        this.file1 = files[0]
      },
      savePieceJointe() {
                let  url = this.domaine + 'caisse/'+ this.typeF + '/' + this.optionPaiement.id + '/new/optionPaiement'
                var form = document.getElementById("formPieceJointe");
                var data = new FormData(form);
                data.append('idUser', this.user.id)
                data.append('idPiece', this.optionPaiement.idPiece)

                this.loading = true

                this.$http.post(url,data).then(response => {
                        if (response.body) {
                                  this.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: 'Piece jointe enregistré avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    })

                          this.dialogShowPiece = false
                          this.showButtonPiece = false
                          this.loading = false
                           this.loadRegement(this.factureCourant, this.typeF),
                         // this.loadCaisse()
                           this.showBanque()

                          // this.showCaisse(this.caisseCourant)
                          //   this.loadRegement(this.factureCourant, this.typeF)

                        }
                    },
                    error => {
                        this.$message.error('Erreur serveur')
                        this.loading = false
                        this.validPaiem = false

                    })
        },
      //enregistrement des images
      onFilepiceJutiPicked(event)
        {
          const files = event.target.files;
          let filename = files[0].name;
          if (filename.lastIndexOf(".") <= 0) {
            return alert("Veuillez selectionner un  format de fichier valide ");
          }

          const fileReader = new FileReader();
          fileReader.addEventListener("load", () => {
            this.pieceJusti = fileReader.result;
          });

          fileReader.readAsDataURL(files[0]);
          this.pieceJusti = files[0];
        },

      showPieceJustifi(item) {
        this.optionPaiement = item
        this.dialogShowPiece = true
        this.showButtonPiece = false
        this.pieceJusti = item.urlPiece
      },
       ClearTransfertForm() {
            this.dialogAjoutTrans = false
            this.$refs['transFertForm'].resetFields();
        },
        imprimerFacture (ligne) {
        let url = ""
           if(ligne.type == 1){
                    url = this.domaine + 'fournisseur/' + ligne.idFact + '/'+ this.user.id +'/imprimer/facture'
            }
            else {
                url = this.domaine + 'fournisseur/' + ligne.idFact + '/'+ this.user.id +'/imprimer/factureParc'
            }
        this.$http.get(url).then(response => {
          if (response.body) {
          }
        })
        window.open(url)
      },
      loadFacture (ligne)
      {
        this.loading = true
        this.caisseCourant = this.detailBanque;
        this.listFacture = [];
        if (this.$refs.formFacture.validate()) {
          var form = document.getElementById('formFacture')
          var data = new FormData(form)
          let url = this.domaine + 'caisse/' + this.caisseCourant.id + '/facture'
          data.append('idUser', this.user.id)
          data.append('fournisseur', this.selectFournisseur)
          data.append('type', this.selectTypeFacture)
          data.append('typeRech', this.typeRech)
          data.append('client', this.selectClient)


          data.append('idDemandeur', this.selectDemandeur)
          data.append('etat', this.selectEtatFacture)
          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.listFacture = verif.facture
                if (this.listFacture.length === 0) {
                  this.$notify({
                    title: 'RESULTATS DE VOTRE RECHERCHE',
                    message: "Aucune facture n'a été trouvée.",
                    type: 'warning',
                    position: 'top-center'
                  })
                } else {
                  this.$notify({
                    title: 'RESULTATS DE VOTRE RECHERCHE',
                    message: this.listFacture.length + " facture(s) ont été trouvée(s).",
                    type: 'success',
                    position: 'top-center'
                  })
                }
              } else if (verif.code === 2) {
                this.$message({
                  message: verif.message,
                  type: 'warning'
                })
                this.loading = false
              } else if (verif.code === 3) {
                this.$message({
                  message: verif.message,
                  type: 'warning'
                })
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }

              this.loading = false
            } else {
              this.$message.error('Erreur serveur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Erreur serveur')
            this.loading = false
          })
        }
      },

        loadRegement (ligne, type)
      {
        this.typeF = type
        this.factureCourant = ligne
        this.dialogLoadReglement = true
        let url = this.domaine + 'caisse/'+ this.typeF +'/'+ this.factureCourant.idFact +'/index/reglement'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listReglement = response.body.paiement

            this.typeF = response.body.typeF


            if(response.body.type != 3) // si ce na'est pas un facture de demande de fonds
            {
              this.readInput = false;

            }
            else {
              this.montantVerse = response.body.total1;
              this.selectEffectue = 1; //"Lui meme"
              this.selectMode = 1; //"espece"
               this.readInput = true;
            }
            this.totalFacture = response.body.total
            this.totalFacture1 = response.body.total1
            this.payeFacture = response.body.paye
            this.payeFacture1 = response.body.paye1
            this.impayeFacture = response.body.impaye
            this.impayeFacture1 = response.body.impaye1
            this.soldeCaisse = response.body.soldeCaisse
            this.dialogAjoutReglement = false
            this.dialogEditReglement = false
            this.dialogEdit = false
          }
        })
      },
      closeLoadReglement () {
        this.dialogLoadReglement = false
        this.dialogAjoutReglement = false
        this.dialogEditReglement = false
        this.dialogEdit = false
      },
      onFileImageLogoPicked(event)
        {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf(".") <= 0)
            {
                return alert("Veuillez selectionner un  format de fichier valide ")
            }

            const fileReader = new FileReader()
            fileReader.addEventListener("load", () => {
                this.urlImage = fileReader.result
            })

            fileReader.readAsDataURL(files[0])
            this.urlImage = files[0]

        },
      onFileImagePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.urlImage = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
    },
      submitReglement () {
        this.loading = true

        if (this.montantVerse > 0 && this.montantVerse <= this.impayeFacture1) {
          let etat = false
          if (this.selectEffectue != "" && this.selectMode != "") {
            if ((this.selectEffectue == 2 && this.remettant == '') || ((this.selectMode != 1 && this.selectMode == 2) && (this.reference == '' || this.selectEncaisse == ''))) {
              etat = false
            } else if ((this.selectEffectue == 2 && this.remettant == '') || ((this.selectMode != 1 && this.selectMode == 3) && (this.reference == ''))) {
              etat = false
            } else {
              etat = true
            }
          } else {
            etat = false
          }

          if (etat == true) {
            if (this.$refs.formReglement.validate()) {
              var form = document.getElementById('formReglement')
              var data = new FormData(form)
              let url = ''
              data.append('idUser', this.user.id)
              data.append('effectue', this.selectEffectue)
              data.append('mode', this.selectMode)
              data.append('encaisse', this.selectEncaisse)
              data.append('urlImage', this.selectEncaisse)

              if (this.reglementCourant.id) {
                url = this.domaine + 'caisse/' + this.reglementCourant.id + '/edit/reglement'
              } else {
                url = this.domaine + 'caisse/'+ this.typeF + '/' + this.factureCourant.idFact + '/new/reglement'
              }


              this.$http.post(url, data).then(response => {
                if (response.body) {
                  let verif = response.body
                  if (verif.code === 1) {
                    if (this.reglementCourant.id) {
                      this.$notify({
                        title: 'MODIFICATION REUSSI',
                        message: 'Paiement modifié avec succès.',
                        type: 'success',
                        position: 'top-center'
                      })
                    } else {
                      this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: 'Paiement enregistré avec succès.',
                        type: 'success',
                        position: 'top-center'
                      })
                    }
                    // this.closeLoadReglement()
                    this.validBanquPaiem = false
                    this.dialogEditReglement = false
                    this.dialogAjoutReglement = false
                    this.$refs.formReglement.reset(),
                    this.loadRegement(this.factureCourant, this.typeF),
                    this.loadCaisse()
                    this.showBanque()
                    this.listFacture = []
                    // this.resetForme()
                    this.loading = false
                     this.dialogEdit = false
                  } else if (verif.code === 0) {
                    this.$message.error(verif.message)
                    this.loading = false
                  }
                } else {
                  this.$message.error('Erreur serveur')
                  this.loading = false
                }
              },
              response => {
                this.$message.error('Erreur serveur')
                this.loading = false
              })
            } else {
              this.$message.error('Veuillez renseigner les champs obligatoires')
              this.$notify.error({
                title: "ERREUR D'ENREGISTREMENT",
                message: "Le paiement n'a pas été enregistré.",
                position: 'top-center'
              })
              this.loading = false
            }
          } else {
            this.validBanquPaiem = false
            this.$message.error('Veuillez renseigner les champs obligatoires')
            this.loading = false
          }
        } else {
          this.$notify.error({
            title: "ERREUR DU MONTANT",
            message: "Le montant versé ne doit pas etre superieur au montant restant.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      imprimeSearchFacture(item) {

        this.selectFournisseur =  this.selectFournisseur != '' ? this.selectFournisseur : "null";
        this.selectTypeFacture =  this.selectTypeFacture != '' ? this.selectTypeFacture : "null";
        this.selectEtatFacture =  this.selectEtatFacture != '' ? this.selectEtatFacture : "null";
        this.dateFacture =  this.dateFacture != '' ? this.dateFacture : "null";

        let url = this.domaine + 'caisse/impression/facture/search/'+item+'/'+this.user.id+'/'+this.selectFournisseur+'/'+this.selectTypeFacture+'/'+this.selectEtatFacture+'/'+this.dateFacture
          window.open(url)

        this.selectFournisseur = ''
        this.selectTypeFacture = ''
        this.selectEtatFacture = ''
        this.dateFacture = ''
      },
      showReglement (ligne) {
          this.dialogShowReglement = true
          this.reglementCourant = ligne
          let url = this.domaine + 'caisse/' + this.reglementCourant.id + '/show/reglement'
          this.$http.get(url).then(response => {
              if (response.body) {
                  this.detailReglement = response.body.paiement
              }
          })
      },
        imprimerReglement (ligne) {
        this.reglementCourant = ligne
        let url = this.domaine + 'caisse/' + this.reglementCourant.id + '/imprimer/reglement/'+this.user.id
        this.$http.get(url).then(response => {
          if (response.body) {
          }
        })
        window.open(url)
      },
      submitValidForm(formName) {

        if(this.image1 != "/static/img-doc.png" ){

          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loading = true
              let form = document.getElementById("formValidCheq")
              //recuperation des demandes
              let data = new FormData(form);
              let url = this.domaine + 'caisse/appro/'+ this.idBanqueCourant +'/confirm/cheque'

              this.$http.post(url, data).then(response => {

                if (response.body) {
                    let verif = response.body
                    if (verif.code === 5) {
                      this.$notify({
                        title: 'FICHIER INVALIDE',
                        message: 'Erreur dans la validation.',
                        type: 'error',
                        position: 'top-center'
                      })
                      this.loading = false
                    } else if(verif.code === 2) {

                      //reinitialiser le formulaire
                      let form = document.getElementById("formValidCheq")
                      this.resetForm('formValidCheq')
                      // this.formDemande.detail = ''
                      //reinitialisation des images telecharger
                      this.image1 = "/static/img-doc.png";
                      this.image2 = "/static/img-doc.png";
                      this.image3 = "/static/img-doc.png";
                      this.image = "/static/img-doc.png";
                      this.file1 = "";
                      this.file2 = "";
                      this.file3 = "";
                      this.loading = false
                      this.successNotif("Validation enregistrée avec succès")
                      this.dialogConfirmCheq = false
                      this.$emit('close')
                      // this.$parent.loadListApproDgCheqBanque();

                    } else if(verif.code === 0) {

                      this.$notify({
                        title: 'MONTANT INSUFFISANT POUR EFFECTUER L\'OPERATION',
                        message: 'Approvisionnement impossible.',
                        type: 'error',
                        position: 'top-center'
                      })
                      this.loading = false
                      this.dialogConfirmCheq = false
                    }

                }

              }, (erreur) => {
                  //reinitialiser le formulaire
                  this.resetForm('formValidCheq')
                  // this.formDemande.detail = ''
                  //reinitialisation des images telecharger
                  this.image1 = "/static/img-doc.png";
                  this.image2 = "/static/img-doc.png";
                  this.image3 = "/static/img-doc.png";
                  this.image = "/static/img-doc.png";
                  this.file1 = "";
                  this.file2 = "";
                  this.file3 = "";
                  this.$message.error("Une erreur est survenue lors de l'enregistrement de la validation")
                  this.dialogConfirmCheq = false
              })
            }
          });

        } else {

           this.$notify({
              title: 'ECHEC DE LA VALIDATION',
              message: 'Veuillez uploader le chèque.',
              type: 'error',
              position: 'top-center'
            })
        }



      },
      successNotif(mess = ""){
        this.$notify({
          title: 'ENREGISTREMENT REUSSI',
          message: mess,
          type: 'success',
          position: 'top-center'
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.formValidCheq.numCheq = ''
        this.formValidCheq.dateSign = ''
      },
      newReglement (ligne) {

          this.dialogAjoutReglement = true
          this.dialogEditReglement = false
          this.urlImage= "/static/doc.png"
          this.file= null
          this.dialogEdit = false
          this.montantVerse = 5
          this.remettant = ''
          this.banque = ''
          this.reference = ''
          this.selectEncaisse = null
          this.selectEffectue = null
          this.selectMode = null
      },
      resetForme(){
        this.urlImage= "/static/doc.png"
          this.file= null
          // this.dialogEdit = false
          this.montantVerse = 5
          this.remettant = ''
          this.banque = ''
          this.reference = ''
          this.selectEncaisse = null
          this.selectEffectue = null
          this.selectMode = null
      },
      loadFournisseur () {
          this.loading = true
          let url = this.domaine + 'fournisseur/index'
          this.$http.get(url).then(response => {
              if (response.body) {
                  this.listFournisseur = response.body.fournisseur
                  this.loading = false
              }
          })
      },
      editRegement (ligne) {
          this.loading = false
           this.urlImage= "/static/doc.png"
          this.file= null
          this.dialogShowReglement = false
          this.dialogAjoutReglement = false
          this.dialogEditReglement = true
          this.dialogEdit = true
          this.reglementCourant = ligne
          this.montantVerse = this.reglementCourant.montant1
          this.remettant = this.reglementCourant.remettant
          this.banque = this.reglementCourant.banque
          this.reference = this.reglementCourant.reference
          this.selectEncaisse = this.reglementCourant.encaisse
          this.selectEffectue = this.reglementCourant.effectue
          this.selectMode = this.reglementCourant.mode
      },
      showBanque () {
          // this.dialogModalBanque = true
          // this.dialogShow = true
        // this.caisseCourant = ligne
          this.listFacture = []
          let url = this.domaine + 'caisse/' + this.detailBanque.id + '/show'
          this.$http.get(url).then(response => {
              if (response.body) {
                  this.detailCaisse = response.body.caisse
                  this.detailBanque = response.body.details
                  this.montantSortie = response.body.montantSortie
                  this.montantEntree = response.body.montantEntree
                  this.montantTvaEntree = response.body.montantTvaEntree
                  this.montantTvaSortie = response.body.montantTvaSortie
                  this.totalEntree = response.body.totalEntree
                  this.totalSortie = response.body.totalSortie
                  this.statCaisse2 = response.body.stats1
                  this.statAllbilanBanque()
              }
          })
      },
      loadCaisse () {
            this.loading = true
            let url = ""
            if(this.droitAcces.caisse){//pour l'admin
                url = this.domaine + 'caisse/index'
            } else if(this.droitAcces.caisse_unique_user){//pour celui qui a crée la caisee
                url = this.domaine + 'caisse/unique/'+ this.user.id +'/user/index'
            }else{
                url = this.domaine + 'caisse/unique/'+ this.user.id +'/index'
            }
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.detailCaisseS = response.body.caisse
                    this.listCaisse = response.body.caisse
                    this.statAllCaisse = response.body.stats
                    // this.statAllbilan()
                    this.loading = false
                }
            })
        },

    },


    mounted () {
      this.loadFournisseur()
      this.loadCaisse()
      this.statAllbilanBanque()

      //  this.showBanque()
      // this.loadListApproDgCheq()
      // this.statAllbilan()  GENERE DES ERREURS AU CHARGEMENT
    }

  };
</script>
<style>
    .el-tabs--border-card
    {
        background: #FAFAFA;
    }

    .tooltip-btn {
    position: relative;
    background-color: grey;
    color: white;
  }

  .tooltip-btn::after {
    content: attr(title);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    color: white;
    transition: opacity 0.9s, visibility 0.9s;
  }

  .tooltip-btn:hover::after {
    opacity: 1;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tresorerie/ModalBanque.vue